import React from 'react';

export const Home = () => {
  return (
    <div>
      <p>.</p>
    </div>
  );
};
